import type { TransactionTableRow } from '@peanuds/shared';

import type { Card, CardTransaction, CardTransactionStatus } from '../cards.types';

const tableStatusByCardStatus: Record<CardTransactionStatus, string> = {
  completed: 'completed',
  processing: 'processing',
  failed: 'failed',
  missing_otp: 'pending',
};

export const toCardTransactionTableRow = (
  transaction: CardTransaction,
  card: Card,
): TransactionTableRow => ({
  id: transaction.id,
  transactionId: transaction.id,
  direction: transaction.direction,
  dateAndTime: transaction.occurredAt,
  amount: transaction.amount,
  currency: card.currency,
  status: tableStatusByCardStatus[transaction.status],
  cardMerchantName: transaction.merchant.name,
});
